module.exports = __webpack_public_path__ + "img/arrow.5cf25670.svg";